import styles from "./AccountButton.module.css";
import { useSelector } from "react-redux";
import { useEffect } from "react";
function AccountButton(){
    let account = useSelector((state)=>state.account);
    console.log("Account Button")
    console.log(account);

    useEffect(() => {}, [account]);
    return (
      <div className={styles.container}>
        <div className={styles.flex}>
          <svg
            width="36"
            height="41"
            viewBox="0 0 36 41"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.5922 36.3582C20.1015 36.3624 22.5672 35.6098 24.7391 34.1767V28.8358C24.7391 27.3395 24.2178 25.9045 23.2899 24.8465C22.362 23.7884 21.1035 23.194 19.7913 23.194H15.3932C14.081 23.194 12.8225 23.7884 11.8946 24.8465C10.9667 25.9045 10.4454 27.3395 10.4454 28.8358V34.1767C12.6173 35.6098 15.0829 36.3624 17.5922 36.3582ZM28.0376 28.8358V31.1853C29.9391 28.8642 31.2044 25.9601 31.6779 22.83C32.1514 19.6999 31.8125 16.4803 30.7028 13.5669C29.5932 10.6535 27.7611 8.17336 25.4319 6.43125C23.1027 4.68914 20.3778 3.76104 17.5922 3.76104C14.8066 3.76104 12.0818 4.68914 9.75254 6.43125C7.42332 8.17336 5.59128 10.6535 4.48162 13.5669C3.37196 16.4803 3.03306 19.6999 3.50656 22.83C3.98006 25.9601 5.24533 28.8642 7.14684 31.1853V28.8358C7.14683 26.8972 7.672 25.006 8.65055 23.4207C9.62909 21.8355 11.0132 20.6336 12.6136 19.9795C11.7832 18.8904 11.2451 17.5519 11.0635 16.1237C10.8818 14.6955 11.0642 13.2379 11.589 11.9247C12.1139 10.6115 12.9589 9.49812 14.0233 8.71741C15.0877 7.93669 16.3266 7.52157 17.5922 7.52157C18.8578 7.52157 20.0968 7.93669 21.1612 8.71741C22.2256 9.49812 23.0706 10.6115 23.5954 11.9247C24.1202 13.2379 24.3027 14.6955 24.121 16.1237C23.9393 17.5519 23.4012 18.8904 22.5708 19.9795C24.1712 20.6336 25.5554 21.8355 26.5339 23.4207C27.5125 25.006 28.0376 26.8972 28.0376 28.8358ZM17.5922 40.1194C22.258 40.1194 26.7326 38.006 30.0318 34.2441C33.331 30.4821 35.1845 25.3799 35.1845 20.0597C35.1845 14.7395 33.331 9.63727 30.0318 5.87535C26.7326 2.11343 22.258 0 17.5922 0C12.9265 0 8.45183 2.11343 5.15265 5.87535C1.85346 9.63727 0 14.7395 0 20.0597C0 25.3799 1.85346 30.4821 5.15265 34.2441C8.45183 38.006 12.9265 40.1194 17.5922 40.1194ZM20.8908 15.0448C20.8908 16.0423 20.5433 16.999 19.9247 17.7043C19.3061 18.4097 18.4671 18.806 17.5922 18.806C16.7174 18.806 15.8784 18.4097 15.2598 17.7043C14.6412 16.999 14.2937 16.0423 14.2937 15.0448C14.2937 14.0472 14.6412 13.0906 15.2598 12.3852C15.8784 11.6798 16.7174 11.2836 17.5922 11.2836C18.4671 11.2836 19.3061 11.6798 19.9247 12.3852C20.5433 13.0906 20.8908 14.0472 20.8908 15.0448Z"
              fill="#ACACAC"
            />
          </svg>

          <div className={`${styles.nameLabel} ${styles.secondFlexItem}`}>
            <p>Username:</p>
            <p>
              {account?.accountInfo.isGuest
                ? account.accountInfo.guestName
                : account.accountInfo.username}
            </p>
          </div>
        </div>
      </div>
    );
}

export default AccountButton;